const BACKEND = process.env.REACT_APP_BACKEND_URL ?? 'http://localhost:8001';

export function mediaUrl(path) {
  if (!path) return null;
  if (path.startsWith('http')) return path;
  return BACKEND + path;
}
